

export function allergyExclusionDisplayText(disclaimer?: string | null | undefined) {
    switch (disclaimer) {
        case "NONE KNOWN":
            return "The resident has no known allergies / adverse reactions. ";

        case "NOT ASKED":
            return "The resident has not been asked about any known allergies / adverse reactions. ";

        case "NONE SUPPLIED":
            return "It is unknown if the resident has any known allergies / adverse reactions. ";
        default:
            return "";
    }
}